import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ListProfs from '../../../components/saude/profissionais';


function ListProfsScreen() {
    return (
        <Fragment>
            <Head titulo="Profissionais da Saúde em Macuco" />
            <Header />
            <Container>
               <ListProfs /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListProfsScreen;